import { useEffect, useState } from "react";
import axios from "axios";
import "../../Styles/auth/auth.scss";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import { useNavigate } from "react-router-dom";
import isoEventLogo from "./../../assets/images/Logo/Logo-Pazirex-Blue.svg";
import LoginStep from "../../utilities/functions/loginProcessStep";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../slices/userSlice";

const registerApiRoute = serverConfig.server.url + apiConfig.api.authControllers.register

const Register = () => {

  const dispatch = useDispatch();
  const { token, roles } = useSelector((state) => state.user);

  const [loading, setLoading] = useState(false);
  const headers = { Authorization: "Bearer " + localStorage.tokenreg };
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const registerRequestParams = {
    first_name: firstName,
    last_name: lastName,
    callback_url: window.location.origin + "/",
  }

  const registerAPI = (e) => {

    e.preventDefault(); // Prevent form submission
    setLoading(true);

    axios.post(registerApiRoute, registerRequestParams, { headers })
      .then((response) => {
        setLoading(false);

        if (response.data.status === "success") {
          localStorage.setItem("token", response.data.data.token);
          localStorage.removeItem("tokenfa");
          localStorage.removeItem("mobile");
          dispatch(
            setUser({
              first_name: response.data.data.first_name,
              last_name: response.data.data.last_name,
              token: response.data.data.token,
              roles: response.data.data.user_roles,
            })
          );

          if (localStorage.getItem("token") || token) {
            localStorage.getItem("callBackURL") &&
              (localStorage.getItem("callBackURL") != "/login" ||
                localStorage.getItem("callBackURL") != "/twofa" ||
                localStorage.getItem("callBackURL") != "/register")
              ? window.location.replace(localStorage.getItem("callBackURL"))
              : window.location.replace("/");
          }
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error making API call:", error);
      });
  };

  useEffect(() => {
    let step = LoginStep();
    if (step !== "OK" && step) {
      navigate(step);
    }

    //   if (localStorage.token) {
    //     navigate("/");
    //   } else if (localStorage.tokenfa) {
    //     navigate("/twofa");
    //   } else if (localStorage.tokenreg) {
    //     // navigate("/register");
    //   }
    // } else {
    //   localStorage.clear();
    //   navigate("/login");
    // }
  }, []);

  return (
    <div className="container-fluid d-flex pt-5 mt-5 justify-content-center">
      <div className="card-group auth-card">
        <div className="card">
          <div className="card-body">
            <img
              src={isoEventLogo}
              className="logo-img d-flex mx-auto my-5"
              alt="..."
            />

            <h5 className="card-title fs-18">مشخصات خود را وارد کنید</h5>
            <p className="fs-14">اطلاعات شما در پذیرکس محفوظ است. </p>
            <form onSubmit={registerAPI}>
              <input
                type="text"
                className="form-control"
                id="firstName"
                placeholder="نام"
                onChange={(e) => {
                  setFirstName(e.target.value);
                }}
                autoFocus
              />
              <input
                type="text"
                className="form-control mt-2"
                id="lastName"
                placeholder="نام خانوادگی"
                onChange={(e) => {
                  setLastName(e.target.value);
                }}
              />
              <button
                className="btn btn-primary mt-4"
                type="submit"
                disabled={loading || !firstName || !lastName}
              // onClick={registerAPI}
              >
                ورود
                {loading && (
                  <span
                    className="spinner-border spinner-border-sm ms-1"
                    role="status"
                    aria-hidden="true"
                  />
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
